import navBarHomepage from '../modules/navbar-homepage';
import config from '../config';

export default () => {
    navBarHomepage.on();
    if (config.get('featureFlags.pollsEnabled') === true) {
        require('../modules/collection_poll')();
    }
};
